import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './Discussions.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
import CommentList from './common/CommentList';
import User from './common/User';
import DiscussionLinks from './common/DiscussionLinks';
import DiscussionContent from './common/DiscussionContent';
import CommentOverlay from './common/CommentOverlay';
import ReplyOverlay from './common/ReplyOverlay';
import UserListOverlay from './common/UserListOverlay';
import Cookies from 'js-cookie';
import { fetchInitialData2 } from "../fetchData";
import copy from 'copy-to-clipboard';
import withLocation from "../../withLocation";

const service = new Service();

class DiscussionsDetail extends Component {
    constructor(props) {
        super(props);
        console.log("DiscussionsDetail props :: ", props);
        let initialData = [];
        let serverSideData = {};
        let userId = Cookies.get('_$FC_UserInfo$_');
        let initialCommentData = [];
        this.totalCount = 0;
        let isWindow = false;
        let isDesktop = true;
        let metaTitle = "Discussions on Pregnancy, Parenting, Baby Care & more";
        let metaDescription = [
            { "name": "description", "content": "Join the Firstcry Parenting discussions and be a part of one of the largest & active online communities. Discuss & stay updated on a host of useful & interesting topics." },
            { "name": "robots", "content": "all" }
        ]
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        console.log("serverSideData ::: ", serverSideData);
        if (serverSideData && serverSideData['msg'] == "1" && serverSideData['result'] && serverSideData['result'] != "No Record Found") {
            let Ary = [];
            Ary.push(serverSideData['result']);
            initialData = Ary;
            initialCommentData = Ary[0]['comment'];
            this.totalCount = parseInt(initialData[0]['commentCount']);
        }
        if (initialData.length > 0) {
            metaTitle = initialData[0].title + " – FirstCry Parenting";
            metaDescription = [
                { "name": "description", "content": "Discuss & express your views on " + initialData[0].title + " at FirstCry Parenting." }
            ]
        }
        this.state = {
            initialData: initialData,
            commentData: initialCommentData,
            isCmtPage: false,
            metaTitle: metaTitle,
            metaDescription: metaDescription,
            displayCpnPopup: false,
            displaySorryPopup: false,
            isCouponVisible: '',
            couponTitle: '',
            couponCode: '',
            couponDescription: '',
            hyperlink:'',
            mapwith: '',
            activityId: '',
            couponId: '',
            user_id: userId,
            initialData: initialData,
            metaTitle: "Discussions on Pregnancy, Parenting, Baby Care & more",
            metaDescription: [
                { "name": "description", "content": "Join the Firstcry Parenting discussions and be a part of one of the largest & active online communities. Discuss & stay updated on a host of useful & interesting topics." }
            ],
            banner_redirection_url: '',
            banner_asset: '',
            banner_heading: '',
            aasset_mobile: '',
            aasset_desktop: '',
            banner_heading: '',
            isWindow: isWindow,
            isDesktop: isDesktop
        };

        this.dId = props ? props.params.title.split('-').pop() : '';
        console.log("discussionId :: ", this.dId);
        this.disPageNo = 1;
        if (props && props.params.page && props.params.page > 0) {
            this.disPageNo = parseInt(props.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var dUrl = reqUrl.split('/')[3];
        var id = "";
        if (dUrl.includes('?')) {
            id = dUrl.split('?')[0].split('-').pop();
        } else {
            id = dUrl.split('-').pop();
        }
        var url = global.api_url + "discussion/getdiscussiondetails";
        let body = JSON.stringify({
            "discussionId": id
        })
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    modifyLinks = (htmlString) => {
        // Add target="_blank" to all <a> tags
        return htmlString.replace(/<a /g, '<a target="_blank" ');
    };

    componentDidMount() {
        // if (this.props.location.search.includes('from=app')) {
        //     document.getElementsByClassName('write-comment')[0].style.bottom = '0';
        // }
        document.addEventListener("click", actions.domClick);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        if (navigator.onLine) {
            this.checkPage();
            let size = 10;
            if (this.disPageNo > 1) {
                size = 10 * this.disPageNo;
            }
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.discussionData();
            } else {
                localStorage.setItem('discussionDetails_' + this.dId, JSON.stringify(this.state.initialData));
                actions.loadSliders();
            }
            if (!this.state.commentData || (this.state.commentData && this.state.commentData.length < 1)) {
                service.showLoader();
                this.commentData(1, size);
            } else {
                localStorage.setItem('discussionComments_' + this.dId, JSON.stringify(this.state.commentData));
                localStorage.setItem('discussionCommentsCnt_' + this.dId, JSON.stringify(this.totalCount));
            }
            actions.loadReadMore();
        } else {
            if (localStorage.getItem('discussionDetails_' + this.dId)) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('discussionDetails_' + this.dId)) }, () => { actions.loadSliders(); actions.loadReadMore(); });
            }
            if (localStorage.getItem('discussionComments_' + this.dId)) {
                this.setState({ commentData: JSON.parse(localStorage.getItem('discussionComments_' + this.dId)) }, () => { actions.loadReadMore(); });
            }
            if (localStorage.getItem('discussionCommentsCnt_' + this.dId)) {
                this.totalCount = localStorage.getItem('discussionCommentsCnt_' + this.dId);
            }
            service.hideLoader();
        }
        actions.setWidth();
    }

    // componentWillMount() {
    //     this.unlisten = this.props.history((location, action) => {
    //         this.checkPage();
    //     });
    // }

    componentWillUnmount() {
        // this.unlisten();
        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", actions.domClick);
    }

    checkPage() {
        this.url = new URL(window.location.href);
        if (this.url.searchParams.get("cid")) {
            this.setState({ isCmtPage: true });
            this.cid = this.url.searchParams.get("cid");
            this.pt = this.url.searchParams.get("pt");
        } else {
            this.setState({ isCmtPage: false }, () => { actions.loadSliders(); });
            this.cid = this.dId;
            this.pt = 0;
        }
    }

    appendURL() {
        // if (this.state.isCmtPage) {
        //     this.props.history.push(service.getRedirectUrl("/discussions/t/" + this.props.params.title + "/page/" + this.disPageNo + "?cid=" + this.cid + "&pt=" + this.pt));
        // } else {
        //     this.props.history.push(service.getRedirectUrl("/discussions/t/" + this.props.params.title + "/page/" + this.disPageNo));
        // }
    }

    pageData() {
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('comment_container')[0]) {
                var cS = document.getElementsByClassName('comment_container')[0].offsetTop;
                var cH = document.getElementsByClassName('comment_container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                if (!((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.disPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.disPageNo;
                        service.showLoader();
                        service.showTracking();
                        _this.commentData(_this.disPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    discussionData() {
        var postData = {
            "discussionId": this.dId
        }
        var url = global.api_ci_url + "Discussions/getdiscussiondetails";
        service.postServiceCall(url, postData).then((json) => {
            if (json && json['msg'] == "1" && json['result'] && json['result'] != "No Record Found") {
                var dataAry = [];
                dataAry.push(json['result']);
                localStorage.setItem('discussionDetails_' + this.dId, JSON.stringify(dataAry));
                this.setState({ initialData: dataAry }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); });
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    commentData(pageno, size) {
        var postData = {
            "recordId": this.cid,
            "postType": this.pt,
            "pageno": pageno,
            "pagesize": size
        }
        var url = global.api_ci_url + "Discussions/getcomment";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result'] && json['result'] != 'Record not found') {
                if (this.state.commentData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ commentData: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.commentData;
                        this.setState({ commentData: ary.concat(json['result']) }, () => { service.loadImages(); actions.loadReadMore(); });
                    }
                    // if (parseInt(pageno) != 1) {
                    //     this.appendURL();
                    // }
                } else {
                    localStorage.setItem('discussionComments_' + this.dId, JSON.stringify(json['result']));
                    localStorage.setItem('discussionCommentsCnt_' + this.dId, JSON.stringify(json['totalComment']));
                    this.totalCount = parseInt(json['totalComment']);
                    this.setState({ commentData: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            service.hideTracking();
        });
    }

    reloadData() {
        var _this = this;
        setTimeout(() => {
            service.showLoader();
            _this.discussionData();
            _this.commentData(_this.disPageNo, (_this.disPageNo * 10));
        }, 500)
    }

    closePopup(){
        const congratsPopup = document.getElementById("coupon_pop_overlay");
        congratsPopup.style.display = "none";
        document.getElementsByTagName('html')[0].style.overflow = 'auto';
    }

    closeBannerPopup = (event) => {
        const congratsPopup = document.getElementById("suggestion-banner-popup");
        document.getElementsByTagName('html')[0].style.overflow = 'visible';
        congratsPopup.style.display = "none";
        this.setState({ banner_redirection_url: '', aasset_mobile: '', banner_heading: '', aasset_desktop:'' });
    }

    closeSorryPopup= ()=>{
        const sorryPopup = document.getElementById("sorry_pop_overlay");
        sorryPopup.style.display = "none";
        document.getElementsByTagName('html')[0].style.overflow = 'auto';
    }

    usePopup=()=>{
        
        // window.location.href = this.state.hyperlink;
        const hyperlink = this.state.hyperlink;
        const url1 = hyperlink.startsWith('https') ? hyperlink : `https://${hyperlink}`;
        window.open(url1, '_blank');

        var postData = {
            "mapwith": this.state.mapwith,
            "activityId": this.state.activityId,
            "couponId": this.state.couponId,
            "user_Id": this.state.user_id 
        }

        var url = global.api_ci_url + "Quiz/setcouponviewflag";
        // console.log("api_ci_url:::", global.api_ci_url);
        service.postServiceCall(url, postData).then((json) => {
            // console.log("getdata response",json);
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });

    }

    cpncodeclick = () => {
        const text = document.getElementById("cpn_code").textContent;
        copy(text, {
            debug: true,
            message: 'Coupon code copied!!'
        });

        const toastElements = document.getElementsByClassName('cpn_pop_toast');
        if (toastElements.length > 0) {
            toastElements[0].style.display = 'block';

            setTimeout(() => {
                toastElements[0].classList.add('fadeout');
                setTimeout(() => {
                    toastElements[0].style.display = 'none';
                }, 1000);
            }, 1500); 
        }
    }

    render() {
        var mainDivStyle = {};
        if (this.state.isCmtPage) {
            mainDivStyle = {
                padding: 0
            }
        }
        const { couponDescription } = this.state;
        const updatedDescription = this.modifyLinks(couponDescription);

        return (
            <main className="discussions-main main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <meta name="atdlayout" content="discussions" />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/discussions")} className="R11_9e">Discussions</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        {this.state.initialData && this.state.initialData[0] && !this.state.isCmtPage &&
                            <span>{this.state.initialData[0].title}</span>
                        }
                        {this.state.initialData && this.state.initialData[0] && this.state.isCmtPage &&
                            <span><a href={service.getRedirectUrl(`/discussions/t/${service.replaceSymbols((this.state.initialData[0].title) + '-' + (this.state.initialData[0].discussionId))}`)}>{this.state.initialData[0].title}</a></span>
                        }
                    </div>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        {this.state.initialData && this.state.initialData.map((discussion, index) =>
                            <div key={index} className="discussion-block" data-title={discussion.title} data-id={discussion.discussionId} id={`discussion_${discussion.discussionId}`} style={mainDivStyle}>
                                {!this.state.isCmtPage &&
                                    <a>
                                        <User user={discussion} isAnonymus={0} eleRef={this} />
                                    </a>
                                }
                                {!this.state.isCmtPage &&
                                    <DiscussionContent discussion={discussion} linkUrl={`JavaScript:Void(0);`} isDisLanding={false} eleRef={this} />
                                }
                                {!this.state.isCmtPage &&
                                    <div className="divider_line"></div>
                                }
                                {!this.state.isCmtPage &&
                                    <DiscussionLinks discussion={discussion} eleRef={this} />
                                }
                                {!this.state.isCmtPage &&
                                    <div className="divider_line comments_count_divider">
                                        {discussion.commentCount < 1000 ?
                                            <div className="totalComment R13_42"> {discussion.commentCount} Comments </div>
                                            :
                                            <div className="totalComment R13_42"> {Number(((discussion.commentCount) / 1000).toFixed(1))}k Comments </div>
                                        }
                                    </div>
                                }
                                {this.state.commentData &&
                                    <CommentList discussion={discussion} comments={this.state.commentData} eleRef={this} />
                                }
                            </div>
                        )}
                        {(!this.state.initialData || this.state.initialData.length < 1) &&
                            <div className="discussion-block invalid-post-cont">
                                <div className="invalid-post-icon">
                                    <span className="icon" data-icon-font="L"></span>
                                </div>
                                <div className="invalid-post-text">
                                    <span className="M17_42">Sorry, this post is no longer available.</span>
                                </div>
                            </div>
                        }
                        {this.state.initialData && this.state.initialData.length > 0 &&
                            <div className="write-comment">
                                <label>
                                    {this.state.commentData && this.state.commentData.length > 0 ?
                                        <input type="text" placeholder="Write your comment here" onClick={() => actions.openParticipatePopup(this.state.initialData[0].discussionId, this.state.initialData[0].title, this.state.initialData[0].discription, this.state.initialData[0].groupId, this.state.initialData[0].categoryId, this.state.initialData[0].urls && this.state.initialData[0].urls[0] ? this.state.initialData[0].urls[0].source : '')} readOnly />
                                        :
                                        <input type="text" placeholder="Be the first to comment" onClick={() => actions.openParticipatePopup(this.state.initialData[0].discussionId, this.state.initialData[0].title, this.state.initialData[0].discription, this.state.initialData[0].groupId, this.state.initialData[0].categoryId, this.state.initialData[0].urls && this.state.initialData[0].urls[0] ? this.state.initialData[0].urls[0].source : '')} readOnly />
                                    }
                                </label>
                                <div data-icon-font="o" className="icon comment-attachment"></div>
                                <div data-icon-font="&#xe00d;" className="icon submit-comment post_comment"></div>
                            </div>
                        }
                    </div>
                </div>
                <input type="hidden" id="post_commentId" value="" />
                <input type="hidden" id="post_parentUserId" value="" />
                <input type="hidden" id="post_parentUserName" value="" />
                <input type="hidden" id="post_parentIsAnonymus" value="" />
                <input type="hidden" id="post_replyId" value="" />
                <input type="hidden" id="post_dId" value="" />
                <input type="hidden" id="post_gId" value="" />
                <input type="hidden" id="post_cId" value="" />
                <input type="hidden" id="post_dUrl" value="" />
                <CommentOverlay eleRef={this} />
                <ReplyOverlay eleRef={this} />
                <UserListOverlay eleRef={this} />
                <div className="share-overlay"></div>
                <Right url={this.props.location.pathname} />
                {/* Banner Popup code start here */}
                    {
                    this.state.aasset_desktop && this.state.banner_redirection_url && this.state.isDesktop &&
                    <div id="suggestion-banner-popup" className="suggestion-banner-popup">
                        <div className="banner-popup-content">
                            <div className="banner-popup-close" onClick={this.closeBannerPopup} >
                                <img src="https://cdn.cdnparenting.com/brainbees/community/images/ic-cross.svg" alt="close icon" title="close icon" />
                            </div>
                            <div className="banner-popup-image-wrapper">
                            {this.state.banner_heading &&
                            <div className="banner-popup-heading M16_21">{this.state.banner_heading}</div>
                            }
                            <div className="banner-popup-image">
                                <a href={this.state.banner_redirection_url} target="_blank" rel="noopener noreferrer">
                                    <img src={this.state.aasset_desktop} alt={this.state.banner_heading} />
                                </a>
                            </div>
                            </div>
                            
                            
                        </div>
                    </div>
                }            
                {
                    this.state.aasset_mobile && this.state.banner_redirection_url && !this.state.isDesktop &&
                    <div id="suggestion-banner-popup" className="suggestion-banner-popup">
                        <div className="banner-popup-content">
                            <div className="banner-popup-close" onClick={this.closeBannerPopup} >
                                <img src="https://cdn.cdnparenting.com/brainbees/community/images/ic-cross.svg" alt="close icon" title="close icon" />
                            </div>
                            <div className="banner-popup-image-wrapper">
                            {this.state.banner_heading &&
                            <div className="banner-popup-heading M16_21">{this.state.banner_heading}</div>
                            }
                            <div className="banner-popup-image">
                                <a href={this.state.banner_redirection_url} target="_blank" rel="noopener noreferrer">
                                    <img src={this.state.aasset_mobile} alt={this.state.banner_heading} />
                                </a>
                            </div>
                            </div>
                            
                            
                        </div>
                    </div>
                }               
                
                {/* Banner Popup code end here */}       




                <Right url={this.props.location.pathname} />
                {/* coupon popup code start */}
                    <div className="coupon_pop_overlay" id='coupon_pop_overlay' style={{display: this.state.displayCpnPopup ? 'block' : 'none',}}>
                  
                        <div className="coupon_popup">
                            <div className="cross_ic_wrap">
                                <div className="close_btn" onClick={this.closePopup}  data-icon-font="C"></div>
                            </div>  
                            <div className="pop_confetti">
                                <lottie-player className="animate" background="transparent" speed="1" loop autoplay src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pop_confetti.json" style={{'width':'450px','height':'auto'}}></lottie-player>
                            </div>
                            <div className="coupon_pop_body">
                                <div className="pop_head_sec">
                                    <div className="pop_heading B22_21">{this.state.couponTitle}</div>
                                    <div className="cpn_code_sec">
                                        <div className="cpn_code_wrap"><div className="cpn_code B16_FF" id='cpn_code'>{this.state.couponCode}</div></div>
                                        <div className="clk_to_copy M16_pink" onClick={this.cpncodeclick}>CLICK TO COPY</div>
                                    </div>
                                </div>
                                <div className="pop_divider_img">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/ds_divider.png" alt="divider" title="divider" />
                                </div>
                                <div className="cpn_pop_toast" ><span className="R14_white">Coupon code copied!!</span></div>
                                <div className="pop_desc_sec">
                                    <div className="desc_title M15_21">Offer Details</div>
                                    <div className="pop_desc R15_42">
                                        <ol>
                                            <div
                                                className="pop_desc R15_42"
                                                dangerouslySetInnerHTML={{ __html: updatedDescription }}
                                            />
                                        </ol>
                                    </div>
                                    <div className="pop_hr_line"></div>
                                    <div className="use_now_btn M16_FF"  onClick={this.usePopup}>USE NOW</div>
                                    <div className="pop_note R14_42">Find all coupons under <a href={`${global.hosturl}my-account/my-earnings`} target="_blank" className="R14_link">My Rewards & Coupons</a> section in Parenting Activities</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sorry_pop_overlay" id='sorry_pop_overlay' style={{display: this.state.displaySorryPopup ? 'block' : 'none',}}>
                                            
                        <div className="sorry_popup">
                            <div className="cross_ic_wrap">
                                <div className="close_btn" onClick={this.closeSorryPopup} data-icon-font="C"></div>
                            </div> 
                            <div className="sorry_pop_body">
                                <div className="top_pink_half"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pink_round1.png" alt="pink half circle" title="pink half circle"/></div>
                                <div className="content_wrap">    
                                    <div className="heading B24_21">Sorry, You Were Close!</div>
                                    <div className="sub_text R16_42">Participate in more Quizzes, Contests & Discussions and stand a chance to win different prizes!</div>
                                </div>
                                <div className="bottom_pink_half"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pink_round2.png" alt="pink half circle" title="pink half circle"/></div>
                            </div>
                        </div>
                    </div>
                    <script src="https://cdn.fcglcdn.com/brainbees/js/m1/json/lottiejson/lottie-player.v2.0.2.min.js"></script>

                {/* coupon popup code end */}
            </main>
        )
    }
}

export default withLocation(DiscussionsDetail);
